import {
  BANNER_LOCALES,
  type BannerHrefByLocale,
  type BannerLocale,
  type BannerVisibleByLocale,
} from '../types/cms';

/**
 * ID45 국가별 링크/노출 정규화 — 폼 상태 ↔ wire 변환.
 *
 * 링크는 공백 trim 후 빈값이면 null(BE href 폴백), 노출은 미지정 시 true 기본.
 * BE 는 누락/null 을 자체 폴백 처리하지만, FE 도 항상 4키를 명시 전송해 의도를 분명히 한다.
 */

export const EMPTY_HREF_BY_LOCALE: BannerHrefByLocale = { ko: null, en: null, ja: null, zh: null };
export const DEFAULT_VISIBLE_BY_LOCALE: BannerVisibleByLocale = { ko: true, en: true, ja: true, zh: true };

/** 단일 로케일 링크 갱신 — 공백 trim 후 빈값은 null 로 정규화. */
export const setHref = (
  map: BannerHrefByLocale,
  locale: BannerLocale,
  value: string,
): BannerHrefByLocale => ({
  ...map,
  [locale]: value.trim() === '' ? null : value,
});

/** 단일 로케일 노출 토글 갱신. */
export const setVisible = (
  map: BannerVisibleByLocale,
  locale: BannerLocale,
  value: boolean,
): BannerVisibleByLocale => ({ ...map, [locale]: value });

/** 응답값(부분/누락 가능)을 항상 4키 맵으로 복원. */
export const normalizeHrefByLocale = (
  partial: Partial<BannerHrefByLocale> | null | undefined,
): BannerHrefByLocale => ({ ...EMPTY_HREF_BY_LOCALE, ...(partial ?? {}) });

export const normalizeVisibleByLocale = (
  partial: Partial<BannerVisibleByLocale> | null | undefined,
): BannerVisibleByLocale => ({ ...DEFAULT_VISIBLE_BY_LOCALE, ...(partial ?? {}) });

export const localeLabels: Record<BannerLocale, string> = {
  ko: '한국어 (KO)',
  en: '영어 (EN)',
  ja: '일본어 (JA)',
  zh: '중국어 (ZH)',
};

export { BANNER_LOCALES };
